import type { DialogProps } from "@mui/material";
import { Dialog } from "@mui/material";
import classNames from "classnames";
import styles from "./styles.module.css";

type Props = DialogProps & {
  className?: string;
};

export const AppDialog: React.FC<Props> = ({ className, ...props }) => {
  return (
    <Dialog className={classNames(styles.container, className)} {...props} />
  );
};
